import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private dataStore: object = {};
  pages: any;

  public TempLangKey = '';
  public langs = ['ar', 'en'];

  // الحصول على البيئة من window object (تم تعيينها في main.ts)
  private get appEnvironment() {
    return (window as any).environment || environment;
  }

  constructor(
    private translateService: TranslateService,

  ) {


  }

  public allowNumbersOnly(event): boolean {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }


  public langObsevable: BehaviorSubject<string> = new BehaviorSubject<string>(
    null
  );

  public onLanguageChanged(lang: string) {
    this.langObsevable.next(lang);
  }
}

export const LocalStorageKeys = {
  COUNTRYID: 'countryId',
  COUNTRYNAME: 'countryName',
  CITYID: 'cityId',
  CITYNAME: 'cityName',
  TOKENOBJECT: 'tokenObject',
  COUNTRY: 'country',
  LANG: 'lang',
  GlameraResources: 'glameraResources',
  DROPDOWN: 'dropdown',
  GLAMERABLOG: 'GlameraBlog',
  USERIDENTITY: 'UserIdentity',
  CurrentBranch: 'CurrentBranch',
  RediredtURLFromAuthGuard: 'RediredtURLFromAuthGuard'
};
